import React from "react";
import styles from "./PageFooter.module.css";
import phoneIcon from "../../img/phone.png";
import emailIcon from "../../img/email.png";
import locationIcon from "../../img/pin.png";
import { StyledInput } from "../StyledInput";

const Newsletter = () => {
	return (
		<div className={styles.newsLetter}>
			<span>Newsletter:</span>
			<p>
				Sign up to receive promotion code, and information about new
				promotions
			</p>
			<form>
				<StyledInput
					type="email"
					name="email"
					placeholder="Type email"
					required
					kind="primary"
				/>
				<button>Sign up</button>
			</form>
		</div>
	);
};

export const PageFooter = () => {
	const phoneNumber = "12 234 212 231";
	const email = "some_email@gm.pl";

	return (
		<div className={styles.footer}>
			<div className={styles.main}>
				<Newsletter />
			</div>
			<div className={styles.side}>
				<div className={styles.contact}>
					<span>Contact</span>
					<div className={styles.icon}>
						<img src={phoneIcon} alt="phone icon" />
						<a href={"tel:" + phoneNumber}>{phoneNumber}</a>
					</div>
					<div className={styles.daysHours}>
						<div>
							<span>mon.-fri.</span>
							<span>sat.-sun.</span>
						</div>
						<div>
							<span>8:00 - 20:00</span>
							<span>8:00 - 18:00</span>
						</div>
					</div>
				</div>
				<div className={styles.icon}>
					<img src={emailIcon} alt="email icon" />
					<a href={"mailto:" + email}> {email}</a>
				</div>
				<div className={styles.icon}>
					<img src={locationIcon} alt="location icon" />
					<a href="/contact">Our shoop</a>
				</div>
			</div>
		</div>
	);
};
